<template>
    <section>
        <div class='container'>
            <div class='text-title'>
                Upgrade Software with Active Subscription
                <p class='text-caption text-italic' runat='server'>Applies to: {{ appliesToText }}</p>
            </div>

            <p>
                LoopCAD and HeatCAD include an automated activation feature making the process of upgrading and activating
                your software easier and faster. If the following applies to you, then you can successfully use this upgrade and auto-activation
                feature:

                <ul>
                    <li>You have an earlier licensed version of the program, and</li>
                    <li>Your <span class='text-weight-medium'>subscription is active</span>, and</li>
                    <li>You are still using the same computer.</li>
                </ul>
            </p>

            <p>
                If your subscription has expired, see the <router-link to='/Support/Help/Renew-CC'>Subscription Renewal</router-link> help topic for
                instructions on how to renew as part of the upgrade process.
            </p>

            <p>
                If you need the setup file to install the software, go to the corresponding downloads page:
            </p>

            <ul style='list-style-type: none;' class='helpTable'>
                <li><router-link to='/Download/LoopCAD'>Download LoopCAD</router-link></li>
                <li><router-link to='/Download/HeatCAD'>Download HeatCAD</router-link></li>
                <li><router-link to='/Download/PlumbingCAD'>Download PlumbingCAD</router-link></li>
            </ul>

            <span class="text-subtitle">Instructions</span>
            <ol class='help-listStyle q-mt-lg'>
                <li>First install the newest version of the software (use links above).</li>
                <li>Run the program <span class='text-weight-medium'>on the computer that you want activated.</span></li>
                <li>
                    <p>If the Activation window does not automatically open, click the <span class='text-weight-medium'>Activate</span> link.</p>
                    <img class="img-fit" :src="require('@/assets/img/help/Activate Link.jpg')" />
                </li>
                <li>
                    <p>Now click the green <span class='text-weight-medium'>Update Activation</span> button.</p>
                    <img class="img-fit" :src="require('@/assets/img/help/UpdateActivation.jpg')" />
                </li>
                <li>Complete the login when prompted.</li>
                <li>
                    The activation code will be generated and automatically applied to your computer. Just click <span class='text-weight-medium'>OK</span> after it is completed.
                </li>
            </ol>
        </div>
    </section>
</template>
<script>
    import { productLines } from '@/plugins/productLines'
    export default {
        name: 'upgrade',
        data() {
            return {
                appliesToText: productLines.LoopCAD.name + ' ' + productLines.LoopCAD.year + ', '
                    + productLines.HeatCAD.name + ' ' + productLines.HeatCAD.year + ', '
                    + productLines.PlumbingCAD.name + ' ' + productLines.PlumbingCAD.year
            }
        }
    }
</script>
